import React from 'react';
import {
  Alert,
  AlertTitle,
  Box, Button, Card, CardHeader, Container, IconButton, Skeleton, Stack, Typography,
} from '@mui/material';
import { OutlinedIcons } from '@marageti/z4-lib';
import { Link } from 'react-router-dom';
import ConfirmDelete from '../../../../components/confirm-delete';
import { ViewProps } from './types';

const {
  OutlinedMinusCircleIcon,
} = OutlinedIcons;

const NonCompeteView = ({
  noCompetesError,
  noCompetesLoading,
  noCompeteToDelete,
  nonCompetes,
  onCancelDelete,
  onConfirmDelete,
  onRemoveNoCompete,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box sx={{
      pt: { desktop: 5, mobile: 2 },
      pb: 9.5,
    }}
    >
      <Stack spacing={3}>
        <Stack spacing={1}>
          <Typography
            variant="h2"
          >
            Non-Compete
          </Typography>
          <Typography variant="body">
            Here you can specify what companies we do not want competing matches with.
          </Typography>
        </Stack>
        <Button
          data-e2e="ztest-partner-no-compete"
          variant="outlined"
          component={Link}
          to="add"
          sx={{ width: { xs: '100%', lg: '110px' } }}
        >
          Add New
        </Button>
        {noCompetesError && (
          <Alert severity="error" sx={{ mt: 4 }}>
            <AlertTitle>There was an error on our end.</AlertTitle>
            {`Code: ${noCompetesError.code}: ${noCompetesError.message}`}
            <br />
            {noCompetesError.id && `ID: ${noCompetesError.id}`}
          </Alert>
        )}
        {noCompetesLoading && (
          <Skeleton variant="rounded" height="100px" width="100%" />
        )}
        {nonCompetes && Object.entries(nonCompetes).map(([key, value]) => (
          <Card key={key} variant="dense">
            <CardHeader
              title={value as string}
              titleTypographyProps={{
                variant: 'captionBold',
                color: 'primary.main',
              }}
              action={(
                <Stack direction="row" spacing={1} alignItems="center">
                  <IconButton onClick={() => onRemoveNoCompete(key)}>
                    <OutlinedMinusCircleIcon color="primary" />
                  </IconButton>
                </Stack>
              )}
            />
          </Card>
        ))}
      </Stack>
    </Box>
    <ConfirmDelete
      open={noCompeteToDelete !== undefined}
      onCancel={onCancelDelete}
      onRemove={onConfirmDelete}
      title="Remove Non-Compete"
      helperText="Are you sure you want to remove this non-compete? We will no longer warn when this competitor is selected during matching."
    />
  </Container>
);

export default NonCompeteView;
